"use client";
import React, { useState } from 'react';
import './SinisterTypes.css';
import ClaimOption from '../ClaimOption/ClaimOption';
import PropTypes from 'prop-types';

const SinisterTypes = ({ setSinisterType }) => {
	const [sinistertypes, setSinistertypes] = useState([
        { type: 0, title: 'Yo iba caminando', selected: false },
        { type: 1, title: 'Yo iba en bicicleta', selected: false },
        { type: 2, title: 'Yo iba en vehículo', selected: false },
        { type: 3, title: 'Yo iba en moto', selected: false },
        { type: 4, title: 'Dañaron mi inmueble', selected: false },
    ]);

    const handleSelectSiniesterType = (sinisterType) => {
        setSinisterType(sinisterType); 
        setSinistertypes(prev =>
            prev.map(sinister => {
                if (sinister.type === sinisterType) {
                    if (sinister.selected) return sinister;
                    return { ...sinister, selected: true };
                }
                return { ...sinister, selected: false };
            })
        );
    };

	return (
		<div className='sinistertypes w-full flex m-auto py-5 px-5 md:px-0'>
			<div className='grid grid-cols-3 md:grid-cols-5 md:max-w-[90%] m-auto gap-5 justify-center items-center'>
				{sinistertypes.map(sinistertype =>
					<ClaimOption key={sinistertype.type} type={sinistertype.type} title={sinistertype.title} selected={sinistertype.selected} handleSelect={() => handleSelectSiniesterType(sinistertype.type)} />
				)}
			</div>
		</div>
	);
};

SinisterTypes.propTypes = {
    setSinisterType: PropTypes.func
};

export default SinisterTypes;